export const LOADER = "LOADER [SETTINGS]";
export const toggleLoader = () => {
  return {
    type: LOADER,
  };
};
